import React from 'react';
import { getStatusByScore } from './utils';
import { Progress } from 'antd';

type Props = {
    score: number;
    passed: number;
    warning: number;
    failed: number;
};

export default function ReportCategoryStatistics({ score, passed, warning, failed }: Props) {
    const total = passed + warning + failed;

    return (
        <div className="category-stats">
            <div className={`stat-element ${getStatusByScore(score)}`}>
                <span className="stat-name">Score: </span>
                <span className="stat-value">{score}</span>
                <Progress
                    percent={score}
                    showInfo={false}
                />
            </div>

            <div className="stat-element failed">
                <span className="stat-name">Failed: </span>
                <span className="stat-value">{failed}</span>
                <Progress
                    percent={(failed * 100) / total}
                    showInfo={false}
                />
            </div>

            <div className="stat-element warning">
                <span className="stat-name">Warnings: </span>
                <span className="stat-value">{warning}</span>
                <Progress
                    percent={(warning * 100) / total}
                    showInfo={false}
                />
            </div>

            <div className="stat-element passed">
                <span className="stat-name">Passed: </span>
                <span className="stat-value">{passed}</span>
                <Progress
                    percent={(passed * 100) / total}
                    showInfo={false}
                />
            </div>
        </div>
    );
}
